import gql from 'graphql-tag'

export const GET_CAMPAIGN_BANNER_RESULT = gql`
  query GetCampaignBannerResult {
    campaignbanner {
      buttonText
      colorTheme
      link {
        url
        text
      }
      published
      text
      title
      unpublished
    }
  }
`
